module.exports = __webpack_public_path__ + "fonts/roboto-v20-latin-500italic.db4a2a2.woff2";